import styled from 'styled-components';
import { BUTTON_SECONDARY } from 'components/TCButton/styles';

export const MainContainer = styled.div`
    margin: 0px 0px 0px 0px;
    width: 100%;
    height: 100%;
    display: flex;
    grid-gap: 16.5px;
`;

export const ButtonContainer = styled.div`  
    ${BUTTON_SECONDARY}{
        width: 150px;    
    }
`;